export default "__VITE_ASSET__9a11f4f0__"